import { render } from "./SelectPay.vue?vue&type=template&id=1678c7ac&scoped=true"
import script from "./SelectPay.vue?vue&type=script&lang=js"
export * from "./SelectPay.vue?vue&type=script&lang=js"

import "./SelectPay.vue?vue&type=style&index=0&id=1678c7ac&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/dayungs_pos_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1678c7ac"]])

export default __exports__